module.exports = __webpack_public_path__ + "static/media/16UNODC17.d9fbe745.jpg";